import { Observable, of as observableOf } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { EventEmitter, Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { ConfirmationDialogComponent, ConfirmDialog } from 'src/app/dialogs/dialog-unsaved-changes/confirmation-dialog.component';
import { PlanEditService } from './plan-edit.service';

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard  {

    dialogConfirmation = new EventEmitter<boolean>();

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
        return component.canDeactivate() ? observableOf(true) : this.openConfirmationDialog().pipe(first());
        // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
        // when navigating away from your angular app, the browser will show a generic warning message
        // see http://stackoverflow.com/a/42207299/7307355
    }

    constructor(private dialog: MatDialog, private planEditService: PlanEditService) { }

    openConfirmationDialog(): Observable<boolean> {

        return new Observable(observer => {
            this.showConfirmationDialog();
            this.dialogConfirmation.subscribe(result => {
                observer.next(result);
                observer.complete();
            });
        });
    }


    private showConfirmationDialog() {
        const confirmDialog = new ConfirmDialog();
        if(this.planEditService.getIsEditing()){
            confirmDialog.message = "Are you sure you want to stop editing your CPD Self-Assessment?";
            confirmDialog.message2 = "The changes to your plan will not be saved.";
        }
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '425px',
            height: '400px',
            panelClass: 'pending-changes',
            data: confirmDialog,
            disableClose: true,
            ariaLabelledBy: 'confirm-desc'
        });
        dialogRef.afterClosed().subscribe(result => {
            if(result === 'ok')
                this.planEditService.setIsEditing(false, 1, null);
            this.dialogConfirmation.emit(result === 'ok');
        });
    }
}
